import { Component, ViewChild } from "@angular/core";
import { SessionService } from "src/app/session.service";
import { DashboardService } from "../../dashboard.service";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { UiService } from "src/app/ui/ui.service";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "app-region-snapshot-widget",
  templateUrl: "./region-snapshot-widget.component.html",
  styleUrls: ["./region-snapshot-widget.component.scss"],
})
export class RegionSnapshotWidgetComponent extends GenericWidgetComponent {
  regionType = "geofences";
  valueType = "visits";
  defaultColumns = ["name"];
  displayedColumns = ["name", "visits"];
  @ViewChild(MatSort) sort!: MatSort;
  regionDataSource!: MatTableDataSource<unknown>;
  regionData: any;
  constructor(
    private DashboardService: DashboardService,
    private SessionService: SessionService,
    private uiService: UiService,
  ) {
    super();
  }

  get accountID() {
    return this.SessionService.currentAccountValue!.accountID;
  }

  get accountAppID() {
    return this.SessionService.currentAppValue!.id;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.initData();
    this.filterForm.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        if (
          this.filterForm.valid &&
          this.filterForm.controls.startDate.value <
            this.filterForm.controls.endDate.value
        ) {
          this.initData();
        }
      });
  }

  initData() {
    this.filterForm.controls.endDate.value.setHours(23, 59, 59);

    this.elementLoader
      .waitForEvent(
        this.DashboardService.getRegionsSnapshot(
          this.accountID,
          this.accountAppID,
          this.filterForm.controls.startDate.value,
          this.filterForm.controls.endDate.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        this.regionData = res;
        console.log;
        this.regionDataSource = new MatTableDataSource(
          this.regionData.geofences,
        );
        this.regionDataSource.sort = this.sort;
      });
  }

  onValueTypeChange() {
    this.displayedColumns = [...this.defaultColumns, this.valueType];
  }

  onRegionTypeChange() {
    const data =
      this.regionType === "geofences"
        ? this.regionData.geofences
        : this.regionData.beacon_regions;
    this.regionDataSource = new MatTableDataSource(data);
    this.regionDataSource.sort = this.sort;
  }
}
